<template>
  <div class="header-component relative">
    <header class="justopp-header fixed-top-strip padding-l-vertical bg-bg z-index-5">
      <div class="padding-2xl-horizontal flex-between flex-middle width-expand l:visible">
        <div class="logo flex-middle gap-l flex-center">
          <saffron-link :to="'/'" class="logo-image flex-bottom flex-middle gap-m">
            <img
              class="logo-image-element"
              :src="getDynamicAssetUrl('images/logos/logob.svg')"
              alt="" />
          </saffron-link>
        </div>

        <div class="header-main flex-middle flex-center gap-xl">
          <nav class="header-nav l:visible">
            <ul class="flex flex-middle gap-l flex-center bold">
              <li>
                <saffron-link class="needs-exact-active" :to="{ name: 'index' }">
                  <span>{{ translateUcFirst("justopp.header.nav.home") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link :to="{ name: 'store-deals' }">
                  <span>{{ translateUcFirst("justopp.header.nav.purchase") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link :to="{ name: 'store-categories' }">
                  <span>{{ translateUcFirst("justopp.header.nav.categories") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'services' },
                  }">
                  <span>{{ translateUcFirst("justopp.header.nav.services") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'about-us' },
                  }">
                  <span>{{ translateUcFirst("justopp.header.nav.about") }}</span>
                </saffron-link>
              </li>
            </ul>
          </nav>
          <div class="header-actions flex gap-m flex-middle flex-center l:visible">
            <user-dropdown v-if="isLoggedIn" style="align-self: center" />

            <saffron-link
              v-if="!isLoggedIn"
              v-slot="{ navigate }"
              class="plain-link c-text flex gap-s"
              :to="{ name: 'user-login' }">
              <icon icon="user-login" @click="navigate"></icon>
              <span class="login-text margin-s-horizontal">{{
                t("justopp.header.loginCta")
              }}</span>
            </saffron-link>

            <saffron-link
              v-if="!isLoggedIn"
              v-slot="{ navigate }"
              class="plain-link"
              :to="{ name: 'user-register' }">
              <form-button
                class="padding-xl-horizontal"
                theme="lead"
                text="justopp.header.solutionsCta"
                @click="navigate"></form-button>
            </saffron-link>

            <saffron-link
              v-if="isLoggedIn && !userVendor"
              v-slot="{ navigate }"
              class="plain-link"
              :to="{ name: 'user-dashboard' }">
              <form-button
                theme="lead-inverse"
                text="justopp.header.profileCta"
                icon="settings"
                @click="navigate"></form-button>
            </saffron-link>

            <saffron-link
              v-if="isLoggedIn && userVendor"
              v-slot="{ navigate }"
              class="plain-link"
              :to="{
                name: 'company-vendorId-dashboard',
                params: { vendorId: userVendor.id },
              }">
              <form-button
                theme="lead-inverse"
                text="justopp.header.companyProfileCta"
                icon="settings"
                @click="navigate"></form-button>
            </saffron-link>

            <div v-show="searchExpanded" class="animate-width-expand">
              <primary-search></primary-search>
            </div>
            <div
              :class="{ 'bg-text': !isLoggedIn }"
              class="rounded-search cursor-pointer flex-center"
              @click="searchExpanded = !searchExpanded">
              <icon size="1.5" icon="search" :class="{ 'bg-bg': !isLoggedIn }"></icon>
            </div>
            <div
              v-if="searchExpanded"
              class="fixed-cover"
              style="top: 98px"
              @click="searchExpanded = false"></div>
          </div>
        </div>
      </div>
      <!-- mobile -->
      <div class="padding-l-horizontal relative flex-middle gap-m width-expand l:hidden">
        <div class="logo flex-middle flex-start">
          <saffron-link class="plain-link logo-image" :to="'/'">
            <img
              class="logo-image-element"
              :class="{ 'move-left': searchExpanded }"
              :src="getDynamicAssetUrl('images/logos/logo-mobile.svg')"
              alt="" />
          </saffron-link>
        </div>

        <div
          class="header-actions flex gap-s flex-middle flex-center l:hidden"
          style="margin-inline-start: auto"
          @click="searchExpanded = !searchExpanded">
          <icon size="2" icon="search"></icon>
          <div
            v-if="searchExpanded"
            style="transform: translateX()"
            class="animate-width-expand">
            <primary-search class="width-250"></primary-search>
          </div>
          <div
            v-if="searchExpanded"
            class="fixed-cover"
            style="top: 75.8px"
            @click="searchExpanded = false"></div>

          <saffron-link
            v-if="!isLoggedIn"
            v-slot="{ navigate }"
            class="plain-link"
            :class="{ 'move-right': searchExpanded }"
            :to="{ name: 'user-register' }">
            <form-button
              theme="lead"
              size="medium"
              text="justopp.header.solutionsCta"
              @click="navigate"></form-button>
          </saffron-link>

          <saffron-link
            v-if="isLoggedIn && !userVendor"
            v-slot="{ navigate }"
            class="plain-link"
            :class="{ 'move-right': searchExpanded }"
            :to="{ name: 'user-dashboard' }">
            <form-button
              theme="lead-inverse"
              text="justopp.header.profileCta"
              class="narrow-button"
              @click="navigate"></form-button>
          </saffron-link>

          <saffron-link
            v-if="isLoggedIn && userVendor"
            v-slot="{ navigate }"
            class="plain-link"
            :class="{ 'move-right': searchExpanded }"
            :to="{
              name: 'company-vendorId-dashboard',
              params: { vendorId: userVendor.id },
            }">
            <form-button
              theme="lead-inverse"
              text="justopp.header.companyProfileCta"
              class="narrow-button"
              @click="navigate"></form-button>
          </saffron-link>
        </div>
        <icon
          class="cursor-pointer l:hidden"
          :class="{ 'move-right': searchExpanded }"
          icon="align-justify-alt"
          theme="text"
          size="2"
          @click="navExpanded = !navExpanded" />
      </div>
      <drawer v-model="navExpanded" class="padding-m-top width-800">
        <template #header-content>
          <div class="flex-row-reverse gap-l padding-m-top">
            <user-dropdown v-if="isLoggedIn" style="align-self: center" />

            <saffron-link
              v-if="!isLoggedIn"
              v-slot="{ navigate }"
              class="plain-link c-text flex-middle gap-s"
              :to="{ name: 'user-login' }">
              <icon icon="user-login" @click="navigate"></icon>
              <span class="login-text margin-s-horizontal">{{
                t("justopp.header.loginCta")
              }}</span>
            </saffron-link>

            <saffron-link
              v-if="!isLoggedIn"
              v-slot="{ navigate }"
              class="plain-link"
              :to="{ name: 'user-register' }">
              <form-button
                theme="lead"
                text="justopp.header.solutionsCta"
                @click="navigate"></form-button>
            </saffron-link>

            <saffron-link
              v-if="isLoggedIn && !userVendor"
              v-slot="{ navigate }"
              class="plain-link"
              :to="{ name: 'user-dashboard' }">
              <form-button
                theme="lead-inverse"
                text="justopp.header.profileCta"
                icon="settings"
                @click="navigate"></form-button>
            </saffron-link>

            <saffron-link
              v-if="isLoggedIn && userVendor"
              v-slot="{ navigate }"
              class="plain-link"
              :to="{
                name: 'company-vendorId-dashboard',
                params: { vendorId: userVendor.id },
              }">
              <form-button
                theme="lead-inverse"
                text="justopp.header.companyProfileCta"
                icon="settings"
                @click="navigate"></form-button>
            </saffron-link>
          </div>
        </template>
        <template #default>
          <nav class="header-nav">
            <ul class="flex-column flex-center text-l semibold">
              <li>
                <saffron-link class="needs-exact-active" :to="{ name: 'index' }">
                  <span>{{ translateUcFirst("justopp.header.nav.home") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link :to="{ name: 'store-deals' }">
                  <span>{{ translateUcFirst("justopp.header.nav.purchase") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link :to="{ name: 'store-categories' }">
                  <span>{{ translateUcFirst("justopp.header.nav.categories") }}</span>
                </saffron-link>
              </li>
              <li> 
                <saffron-link
                  :to="{ name: 'content-styled-article-alias', params: { alias: 'services' } }">
                  <span>{{ translateUcFirst("justopp.header.nav.services") }}</span>
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  :to="{ name: 'content-styled-article-alias', params: { alias: 'about-us' } }">
                  <span>{{ translateUcFirst("justopp.header.nav.about") }}</span>
                </saffron-link>
              </li>
            </ul>
            <div
              class="contact-items flex-between flex-middle width-expand margin-xl-top">
              <div
                class="footer-contact-item footer-contact-item--social width-expand flex-reverse flex-center gap-m">
                <a href="https://www.linkedin.com/company/justopp/" target="_blank">
                  <icon-halo
                    halo-theme="bg"
                    theme="text"
                    :size="1.5"
                    icon="linkedin"
                    class="cursor-pointer"></icon-halo>
                </a>
              </div>
            </div>
          </nav>
        </template>
      </drawer>
    </header>
    <div class="spacer" style="height: 96px"></div>
  </div>
</template>

<script>
import PrimarySearch from "@/client/applications/justopp/components/widgets/PrimarySearch";
import UserDropdown from "@/client/applications/justopp/components/widgets/UserDropdown.vue";

export default {
  components: {
    PrimarySearch,
    UserDropdown,
  },
  data: function () {
    return {
      navExpanded: false,
      searchExpanded: false,
      searchText: "",
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    userProfile() {
      return this.$store.getters["user/profile"];
    },
    userVendor() {
      if (!this.userProfile) {
        return false;
      }

      if (!this.userProfile.Vendor) {
        return false;
      }

      return this.userProfile.Vendor;
    },
  },
};
</script>

<style scoped lang="scss">
.justopp-header .logo-image-element {
  @media (max-width: 1024px) {
    height: 30px;
  }

  height: 58px;

  @media (min-width: 1024px) {
    width: auto;
  }
}
.header-nav ul {
  padding: 0;
  list-style: none;
  margin: 0;

  li {
    a {
      color: var(--c-text);
      font-weight: 400;
      transition: color 0.4s ease 0s;

      &.router-link-exact-active,
      &.router-link-exact-active:hover {
        color: var(--c-lead);
      }

      &.active:not(.needs-exact-active),
      &.active:not(.needs-exact-active):hover {
        color: var(--c-lead);
      }

      &:hover {
        color: var(--c-lead);
        text-decoration: none;
      }
    }

    @media screen and (max-width: 767px) {
      border-bottom: 2px solid var(--c-gray-2);

      a {
        display: block;
        padding-top: var(--margin-l);
        padding-bottom: var(--margin-l);
      }
      &:last-of-type {
        a {
          border-bottom: none;
        }
      }
    }
  }
}
a:hover .login-text {
  opacity: 0.6;
}

.rounded-search {
  padding: calc(var(--margin-s) * 1.25);
  border-radius: 50%;
}

.profile-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.narrow-button {
  padding-inline: 0.5em;
}

@keyframes width-expanded {
  from {
    width: 0;
  }

  to {
    width: 255px;
  }
}
.animate-width-expand {
  animation-name: width-expanded;
  animation-duration: 0.2s;
  width: 0px;
  animation-fill-mode: forwards;
  overflow: hidden !important;
}

.move-left {
  margin-left: -150px;
  transition: margin 0.2s ease-out;
}

.move-right {
  transform: translateX(200px);
  transition: transform 0.2s ease-out;
}
</style>
